import { render, staticRenderFns } from "./ProductFormDialogMove.vue?vue&type=template&id=64fe6977"
import script from "./ProductFormDialogMove.vue?vue&type=script&lang=ts"
export * from "./ProductFormDialogMove.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports